module.exports = __webpack_public_path__ + "media/assets/bookingStepsMobile-f3814448c6a7d4fd3ccf5e7dfdf914ff.png";